<app-checkbox
  *ngIf="showTitle"
  [isChecked]="allPassengersCheck"
  label="{{ 'itinerary-info.passengers-info.list-title' | translate }}"
  (checked)="selectAll($event)"
  id="passengersCheckbox"
  textForm="none"
  side="left"
  [bold]="true"
  [checkboxVisible]="enabledCheckboxes && somePassengerHasTicket"
  labelVisible="true"
></app-checkbox>

<ng-container *ngFor="let passenger of passengers; let i = index">
  <div class="passenger" id="passengerBox{{ i }}">
    <input type="checkbox" id="handle{{ i }}" [(ngModel)]="passenger.isOpen" />
    <div
      class="box is-paddingless"
      [class.is-box-start]="passengers.length > 1 && i === 0"
      [class.is-box-end]="passengers.length > 1 && i === passengers.length - 1"
      [class.is-box]="passengers.length > 1 && i !== passengers.length - 1 && i !== 0"
    >
      <div
        class="columns is-mobile is-centered is-marginless is-vcentered"
        [ngClass]="{ 'infant-reasignated': passenger.type == 'infant' && isInfantReasignated }"
      >
        <div class="passenger-title column is-10 is-vcentered d-inherit">
          <app-checkbox
            [class.pl-4]="!passenger.ticket?.number"
            [isChecked]="passenger.isSelected"
            label=" {{ passenger.firstName | lowercase }} {{ passenger.lastName | lowercase }}"
            (checked)="check(i)"
            id="passenger{{ i }}"
            side="right"
            size="1em"
            [checkboxVisible]="
              (isAirline && enabledCheckboxes) || (enabledCheckboxes && passenger.ticket?.number)
            "
            labelVisible="true"
          ></app-checkbox>
          &nbsp;
          <span *ngIf="passenger.type != 'adult'" class="tag is-light is-capitalized">{{
            'shared.' + passenger.type | translate
          }}</span>
        </div>
        <div class="column is-2 is-vcentered has-text-centered">
          <a (click)="expand($event, i)" class="arrow"></a>
        </div>
      </div>
      <div class="content">
        <div *ngIf="passenger.type == 'infant' && isInfantReasignated">
          <div class="card-content is-size-6">
            <div class="flex-center">
              <div class="infant-text">
                <em class="mdi mdi-alert has-text-warning"></em> &nbsp;
                <p>{{ 'layout.alert-messages.infant-reassigned' | translate }}:</p>
              </div>

              <p>
                {{ adultSelected.toAdultFullName }}
              </p>

              <button class="button is-link is-outlined" (click)="clearReassignment(passenger)">
                {{ 'layout.alert-messages.clear-reassignment' | translate }}
              </button>
            </div>
          </div>

          <div class="card-separator"></div>
        </div>

        <div class="flex-center">
          <div class="card-content is-size-6">
            <button
              (click)="modalSpecialRequests(passenger)"
              class="button is-link is-outlined ml-1"
            >
              {{ 'itinerary-info.passengers-info.special-requests' | translate }}
            </button>

            <button
              *ngIf="passenger.type == 'infant' && !isInfantReasignated"
              (click)="modalInfantReasignation(passenger)"
              class="button is-link is-outlined ml-1"
            >
              {{ 'itinerary-info.passengers-info.reassign-infant' | translate }}
            </button>
          </div>
        </div>

        <div class="card-content is-size-6">
          <app-passenger-ticket
            [ticketSegments]="passenger.ticket?.segments"
            [iataNumberCode]="iataNumber"
            [isAirline]="isAirline$ | async"
            [fligthNumber]="fligthNumber"
          >
          </app-passenger-ticket>
        </div>

        <div *ngIf="passenger.ticket?.number" class="card-separator"></div>

        <div class="card-content is-size-6 weight-medium">
          <p>
            {{ 'itinerary-info.passengers-info.ticket-number' | translate }}:
            <span class="has-text-weight-normal">
              {{ passenger.ticket?.number }}
            </span>
          </p>
          <p>
            {{ 'itinerary-info.passengers-info.emission-date' | translate }}:
            <span
              class="has-text-weight-normal"
              attr.data-title="{{ passenger.ticket?.issuedDate }}"
            >
              {{ passenger.ticket?.issuedDate | date | localizedDate : 'dd MMM y ' }}
            </span>
          </p>
          <p>
            {{ 'itinerary-info.passengers-info.emission-country' | translate }}:
            <span class="has-text-weight-normal">
              {{ passenger.ticket?.issuerCountry }}
            </span>
          </p>
          <p>
            {{ 'itinerary-info.passengers-info.type' | translate }}:
            <span class="has-text-weight-normal is-capitalized">
              {{ passenger.type }}
            </span>
          </p>
          <p>
            {{ 'itinerary-info.passengers-info.document' | translate }}:
            <span class="has-text-weight-normal">
              {{ passenger.documentNumber }}
            </span>
          </p>
          <p>
            {{ 'itinerary-info.passengers-info.documentType' | translate }}:
            <span class="has-text-weight-normal">
              {{ passenger.documentType }}
            </span>
          </p>
          <p>
            {{ 'itinerary-info.passengers-info.birth-date' | translate }}:
            <span class="has-text-weight-normal">
              {{ getBirthDate(passenger) | date | localizedDate : 'dd/MM/yyyy' }}
            </span>
          </p>
          <p>
            {{ 'itinerary-info.passengers-info.age' | translate }}:
            <span class="has-text-weight-normal">
              {{ passenger.age }}
            </span>
          </p>
          <p>
            {{ 'seats.option-detail.seat-number' | translate }}:
            <span class="has-text-weight-normal">
              {{ passenger.ticket?.preReserveSeat }}
            </span>
          </p>
          <p>
            {{ 'itinerary-info.passengers-info.phone-number' | translate }}:
            <span class="has-text-weight-normal">
              {{ passenger.phoneNumber }}
            </span>
          </p>
          <p>
            {{ 'itinerary-info.passengers-info.mail' | translate }}:
            <span class="has-text-weight-normal">
              {{ passenger.email | lowercase }}
            </span>
          </p>
          <p *ngIf="passenger.adultInCharge != null">
            {{ 'itinerary-info.passengers-info.responsibleAdult' | translate }}:
            <span class="has-text-weight-normal">
              {{ passenger.adultInCharge | titlecase }}
            </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<div *ngIf="ticketsReissuedByAirline.length > 0" class="box mt-3">
  <div class="label-left weight-medium mb-1">
    {{ 'itinerary-info.passengers-info.tag-syssys' | translate }}
  </div>
  <div *ngFor="let item of ticketsReissuedByAirline" class="is-family-monospace">
    {{ item }}
  </div>
</div>

<app-special-request-modal
  [isActive]="showSpecialRequests"
  [name]="passengerSelected?.firstName + ' ' + passengerSelected?.lastName"
  [specialRequests]="passengerSelected?.specialRequests"
  (closeModal)="modalSpecialRequests($event)"
></app-special-request-modal>

<app-infant-reasignation-modal
  [isActive]="showInfantReasignationModal"
  [name]="passengerSelected?.firstName + ' ' + passengerSelected?.lastName"
  [infantID]="passengerSelected?.id"
  [allPassengers]="passengers"
  [adultInCharge]="passengerSelected?.adultInCharge"
  (acceptModal)="modalInfantReasignationAccepted($event)"
  (closeModal)="modalInfantReasignation($event)"
></app-infant-reasignation-modal>
